import React from 'react';
import { Card, CardContent } from '../components/ui/card';

const PrivacyPage = () => {
  return (
    <div className="min-h-screen bg-gray-50 dark:bg-gray-900">
      <div className="container mx-auto px-4 py-12">
        <div className="max-w-4xl mx-auto">
          <h1 className="text-4xl font-bold text-gray-900 dark:text-white mb-4">Privacy Policy</h1>
          <p className="text-gray-600 dark:text-gray-400 mb-8">Last updated: January 2025</p>

          <Card className="border-gray-200 dark:border-gray-800">
            <CardContent className="pt-6 space-y-6">
              <div>
                <h2 className="text-2xl font-bold text-gray-900 dark:text-white mb-3">Your Privacy Matters</h2>
                <p className="text-gray-700 dark:text-gray-300">
                  At DevTools Hub, we take your privacy seriously. This policy explains how we handle your information.
                </p>
              </div>

              <div>
                <h3 className="text-xl font-semibold text-gray-900 dark:text-white mb-2">Data Processing</h3>
                <p className="text-gray-700 dark:text-gray-300 mb-2">
                  All tools on our platform run entirely in your browser using JavaScript. This means:
                </p>
                <ul className="list-disc list-inside space-y-1 text-gray-700 dark:text-gray-300 ml-4">
                  <li>Your data never leaves your device</li>
                  <li>We don't store or transmit any of your input data</li>
                  <li>No server-side processing occurs</li>
                  <li>Complete privacy and security for your sensitive information</li>
                </ul>
              </div>

              <div>
                <h3 className="text-xl font-semibold text-gray-900 dark:text-white mb-2">Cookies and Tracking</h3>
                <p className="text-gray-700 dark:text-gray-300">
                  We use minimal cookies only for:
                </p>
                <ul className="list-disc list-inside space-y-1 text-gray-700 dark:text-gray-300 ml-4">
                  <li>Remembering your theme preference (light/dark mode)</li>
                  <li>Basic analytics to improve our service</li>
                  <li>No tracking across other websites</li>
                </ul>
              </div>

              <div>
                <h3 className="text-xl font-semibold text-gray-900 dark:text-white mb-2">Third-Party Services</h3>
                <p className="text-gray-700 dark:text-gray-300">
                  We may use Google AdSense for advertisements. Please refer to Google's privacy policy for information 
                  about how they collect and process data.
                </p>
              </div>

              <div>
                <h3 className="text-xl font-semibold text-gray-900 dark:text-white mb-2">Your Rights</h3>
                <p className="text-gray-700 dark:text-gray-300">
                  Since we don't collect or store your personal data, you maintain complete control over your information. 
                  You can clear your browser's local storage at any time to remove any locally stored preferences.
                </p>
              </div>

              <div>
                <h3 className="text-xl font-semibold text-gray-900 dark:text-white mb-2">Contact Us</h3>
                <p className="text-gray-700 dark:text-gray-300">
                  If you have any questions about this privacy policy, please contact us at privacy@devtoolshub.com
                </p>
              </div>
            </CardContent>
          </Card>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPage;